{
  "bliksy": {
    "inputPlaceholder": "Ask anything",
    "disclaimer": "BLIKSY is AI-assisted and may produce errors. Please double-check responses.",
    "resizeHandle": "Resize chat panel"
  },
  "voiceInput": {
    "startRecording": "Start voice recording",
    "stopRecording": "Stop recording",
    "cancelRecording": "Cancel recording",
    "transcribing": "Transcribing...",
    "microphoneDenied": "Microphone access denied.",
    "recordingFailed": "Recording failed. Please try again.",
    "transcriptionFailed": "Failed to transcribe audio. Please try again."
  },
  "chat": {
    "sendMessage": "Send message",
    "transcript": "Chat transcript",
    "messageFailed": "This message could not be displayed.",
    "retry": "Try again",
    "sourcesLabel": "Sources",
    "chart": {
      "loading": "Preparing chart…",
      "failed": "The chart could not be created.",
      "hoursSuffix": "{{value}}h",
      "percentSuffix": "{{value}}%",
      "coverageOmitted": "{{omitted}} of {{requested}} entries are not shown.",
      "coverageTruncated": "Only the largest {{rendered}} entries are shown.",
      "pointLabels": {
        "restricted": "No access",
        "unknown": "Unknown",
        "unassigned": "Unassigned"
      }
    },
    "diagram": {
      "label": "Diagram",
      "loading": "Preparing diagram…",
      "failed": "The diagram could not be displayed.",
      "expand": "Enlarge diagram",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "resetZoom": "Reset view"
    },
    "document": {
      "preparing": "Preparing file…",
      "failed": "The export could not be created.",
      "download": "Download file",
      "rows": "{{rows}} rows · available until {{expiry}}",
      "partialRows": "First {{rows}} rows · available until {{expiry}}",
      "rowsOnly": "{{rows}} rows",
      "partialRowsOnly": "First {{rows}} rows",
      "omitted": "{{omitted}} rows are not included.",
      "expired": "This file is no longer available.",
      "downloadFailed": "The download could not be started."
    },
    "entityView": {
      "loading": "Preparing view…",
      "unavailable": "This view is no longer available.",
      "noDecisionRules": "This step no longer has a decision table.",
      "loadFailed": "The view could not be loaded.",
      "current": "Current view",
      "updatedAt": "Updated {{date}}",
      "untitledStep": "Unnamed step",
      "openProcess": "Open process",
      "openFullscreen": "Open fullscreen",
      "exitFullscreen": "Exit fullscreen"
    },
    "entityCard": {
      "loading": "Loading details…",
      "unavailable": "This record is no longer available.",
      "loadFailed": "The details could not be loaded."
    },
    "attachment": {
      "fallbackName": "File",
      "label": "Attached file",
      "attach": "Attach a file",
      "remove": "Remove attachment",
      "dropHint": "Drop a PDF or image here",
      "uploading": "Uploading...",
      "tooMany": "At most {{max}} files per message",
      "unsupported": "PDF, PNG or JPEG files only",
      "tooLarge": "At most {{maxMegabytes}} MB",
      "uploadFailed": "Upload failed"
    },
    "feedback": {
      "thumbsUp": "Helpful",
      "thumbsDown": "Not helpful",
      "commentTitle": "What was wrong with this answer?",
      "commentPlaceholder": "Tell us what went wrong",
      "commentSend": "Send",
      "error": "Your feedback could not be saved."
    }
  },
  "thinkingPhases": {
    "stepSummary": {
      "start1": "Analyzing task…",
      "middle1": "Generating summary…",
      "end1": "Polishing wording…"
    },
    "chat": {
      "start1": "Reading your question…",
      "start2": "Making sense of your question…",
      "middle1": "Searching for relevant info…",
      "middle2": "Cross-checking sources…",
      "middle3": "Reviewing the process model…",
      "end1": "Composing answer…",
      "end2": "Polishing wording…"
    }
  }
}
